var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"precisePost"},[_c('div',{staticClass:"title"},[_c('van-button',{attrs:{"type":"info","block":""}},[_vm._v("精准匹配")])],1),_c('listPost',{attrs:{"type":"precisePost"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }